import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import PhoneInputWithCountrySelect from "react-phone-number-input";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "600px",
    alignItems: "center",
    gap: "40px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "center",
    gap: "20px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "stretch",
  gap: "40px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "720px",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "left",
  },
}));

export const CardImage = styling("img")((props) => ({
  width: "50%",
  // height: "100%",
  borderRadius: "8px",
  maxHeight: "100%",
  maxWidth: "50%",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    maxWidth: "550px",
    height: "auto",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "300px",
    maxWidth: "100%",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "24px",
  width: "50%",
  padding: "40px",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    maxWidth: "720px",
    alignItems: "center",
    padding: "0px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "40px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: props.type == "desc" ? "30px" : "48px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.06px",

  "& i": {
    color: "#512ACC",
  },

  [props.theme.breakpoints.down("lg")]: {
    textAlign: props.type == "desc" ? "center" : "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    textAlign: props.type == "desc" ? "left" : "left",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  height: "48px",
  padding: "12px 16px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "8px",
  color: "rgba(0,0,0,0.87)",
  boxShadow: "0px 2px 4px 0px rgba(104, 77, 0, 0.40)",
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0.1px",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  background: "#FFDA07",
  maxWidth: "280px",

  "&:hover": {
    backgroundColor: "#FFDA07",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "1rem",
    lineHeight: "150%",
    letterSpacing: "0.1px",
    minWidth: "280px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "280px",
    paddingInline: "1rem",
    height: "48px",
  },
}));

export const InputWrapper = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  width: "100%",
  alignItems: "flex-start",
}));

export const InputTitle = styling(Typography)({
  fontSize: "12px",
  lineHeight: "18px",
  color: `rgba(0, 0, 0, 0.87)`,
  fontWeight: 500,
});

export const FieldContent = styling(Grid)((props) => ({
  display: "grid",
  gap: props?.companyDetails ? "24px 12px" : "0px 12px",
  gridTemplateColumns: "repeat(2, 1fr)",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: "16px",
  },
}));

export const ExclamationCircleIconStyled = styling(ExclamationCircleIcon)(
  (props) => ({
    height: "16px",
    width: "16px",
    color: "#F75443",
    minWidth: "16px",
  })
);

export const ErrorTextStyled = styling(Typography)((props) => ({
  fontSize: "12px",
  lineHeight: "18px",
  color: "#F75443",
}));

export const PhoneInputStyled = styling(PhoneInputWithCountrySelect)(
  (props) => ({
    /* This is done to stretch the contents of this component. */
    display: "flex",
    alignItems: "center",
    width: "100%",
    position: "relative",

    borderRadius: "8px",
    /* padding: 6px 16px; */
    border: "2px solid #D8d8d8",

    "&.error": {
      border: "2px solid #d32f2f !important",
    },

    "&:hover": {
      border: "2px solid #000",
    },

    "&.PhoneInput--focus": {
      border: "1px solid #512ACC !important",
    },

    "& .PhoneInputInput": {
      flex: "1",
      /* The phone number input should shrink
         to make room for the extension input */
      border: "none",
      borderRadius: "0 3px 3px 0",
      fontFamily: "Inter",
      padding: "8px",
      fontSize: "14px",
      background: "#FFF",
    },

    "& .PhoneInputCountryIcon": {
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      marginRight: "8px",
    },

    "& .PhoneInputCountryIcon--square": {
      width: "var(--PhoneInputCountryFlag-height)",
    },

    "& .PhoneInputCountryIcon--border": {
      backgroundColor: "var(--PhoneInputCountryFlag-backgroundColor--loading)",
      boxShadow:
        "0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor), inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);",
    },

    "& .PhoneInputCountryIconImg": {
      display: "block",
      width: "100%",
      height: "fit-content",
      borderRadius: "3px",
    },

    "& .PhoneInputInternationalIconPhone": {
      opacity: "var(--PhoneInputInternationalIconPhone-opacity)",
    },

    "& .PhoneInputInternationalIconGlobe": {
      opacity: "var(--PhoneInputInternationalIconGlobe-opacity)",
    },

    "& .PhoneInputCountry": {
      position: "relative",
      alignSelf: "stretch",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: "none",
      padding: 0,
      /* background-color: rgba(81, 42, 204, 0.1); */
      background:
        "linear-gradient(0deg, rgba(81, 42, 204, 0.18) 0%,  rgba(81, 42, 204, 0.18) 100%), #dedede",
      width: "100%",
      maxWidth: "68px",
      height: "100%",
      minHeight: "36px",
      borderRadius: "8px 0px 0px 8px",
    },

    "& .PhoneInputCountrySelect": {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      zIndex: 1,
      border: 0,
      opacity: 0,
      cursor: "pointer",
    },

    "& .PhoneInputCountrySelect[disabled], .PhoneInputCountrySelect[readonly]":
      {
        cursor: "default",
      },

    "& .PhoneInputCountrySelectArrow": {
      position: "absolute",
      top: "50%",
      marginTop: "-2px",
      marginLeft: "25px",
      left: "25px",
      width: 0,
      height: 0,
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderTop: "4px solid #707070",
    },

    "& .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputCountrySelectArrow":
      {
        opacity: "1",
        color: "var(--PhoneInputCountrySelectArrow-color--focus)",
      },

    "& .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border": {
      boxShadow:
        "0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus), inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus)",
    },

    "& .PhoneInputCountrySelect + .PhoneInputCountryIcon + .PhoneInputInternationalIconGlobe":
      {
        opacity: "1",
        color: "var(--PhoneInputCountrySelectArrow-color--focus)",
      },

    "& .PhoneInputInput:focus-visible": {
      outline: "none !important",
    },
  })
);
